import React, { Component, Fragment } from 'react';

import './PaymentManagementCard.css';
import { inject, observer } from 'mobx-react';
import AirButton from "../../../../common/components/AirButton";
import PaymentMethodPopup from "./PaymentMethodPopup";
import { Spin } from "antd";
import {api} from "../../../../services";
import {reaction} from "mobx";

const CreditCardPaymentMethod = inject('translationsStore')(({translationsStore, defaultPaymentMethod}) => {

  return (
    <Fragment>
      <span style={{fontSize: '18px'}}>{translationsStore.translate('paymentManagement.creditCard')}</span>
      <div className={'PaymentMethodDetailsContainer'}>
        <div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.paymentType')}
            <div className={'paymentType'}>{defaultPaymentMethod.CreditCardType}</div>
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.cardNumber')}
            <input className={'InputPaymentDetails'} value={defaultPaymentMethod.CreditCardMaskNumber} disabled />
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.expirationDate')}
            <div className={'PaymentMethodExpirationDateRow'}>
              <input className={'InputPaymentDetails'} value={defaultPaymentMethod.CreditCardExpirationMonth} disabled />
              <input className={'InputPaymentDetails'} style={{marginLeft: '20px'}} value={defaultPaymentMethod.CreditCardExpirationYear} disabled />
            </div>
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.cardHolder')}
            <input className={'InputPaymentDetails'} value={defaultPaymentMethod.CreditCardHolderName} disabled />
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.country')}
            <input className={'InputPaymentDetails'} value={defaultPaymentMethod.CreditCardCountry} disabled />
          </div>
        </div>
      </div>
    </Fragment>
  );
});

const BankTransferPaymentMethod = inject('translationsStore')(({translationsStore, defaultPaymentMethod}) => {

  return (
    <Fragment>
      <span style={{fontSize: '18px'}}>{translationsStore.translate('paymentManagement.bankTransferSepa')}</span>
      <div className={'PaymentMethodDetailsContainer'}>
        <div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.paymentType')}
            <div className={'paymentType'}>{defaultPaymentMethod.BankTransferType}</div>
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.bankName')}
            <input className={'InputPaymentDetails'} value={defaultPaymentMethod.BankName} disabled />
          </div>
          <div className={'PaymentMethodDetailsItem'}>
            {translationsStore.translate('paymentManagement.accountNumber')}
            <input className={'InputPaymentDetails'} value={defaultPaymentMethod.BankTransferAccountNumberMask} disabled />
          </div>
        </div>
      </div>
    </Fragment>
  );
});

@inject('translationsStore', 'commonStore')
@observer
export default class PaymentManagementCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visiblePaymentMethodPopUp: false,
      customerDetails: undefined,
    }
  }

  componentDidMount = async () => {
    const { commonStore } = this.props;

    if (!commonStore.dealer) {
      await api('dealer profile').then(dealer => {
        commonStore.setDealer(dealer);
      });
    }

    reaction(
      () => commonStore.dealer,
      async dealer => {

        if (dealer && dealer.masterApiUserUuid) {
          await api('getConnectionRequestFleetCustomerDetails', dealer.masterApiUserUuid)
            .then(customerDetails => {
              this.setState({customerDetails});
            })
            .catch(() => undefined);

          this.loadPaymentsMethods();
        }
      },
      { fireImmediately: true }
    );
  }

  loadPaymentsMethods = () => {
    const { commonStore } = this.props;
    this.setState({isLoading: true});

    try {

      api('getZuoraPaymentMethods', commonStore.dealer.masterApiUserUuid)
        .then(result =>
          this.setState({
            paymentMethods: result.records,
            defaultPaymentMethod: result.defaultPaymentMethod,
            selectedPaymentMethod: result.defaultPaymentMethod ? result.records.find(pm => pm.Id === result.defaultPaymentMethod) : undefined,
            isLoading: false
          })
        );
    } catch (err) {

      this.setState({isLoading: false});
    }
  }

  toggleModalAddPaymentMethod = () => {
    this.setState(prevState => {return {visiblePaymentMethodPopUp: !prevState.visiblePaymentMethodPopUp}});
  }

  render() {
    const { translationsStore } = this.props
      , { selectedPaymentMethod: defaultPaymentMethod, customerDetails, isLoading } = this.state;

    return (
      <Fragment>
        <Spin
          spinning={isLoading}
        >
          <div className={'PaymentManagementCard'}>
            {!defaultPaymentMethod && <div className={'AddFirstPaymentMethodContainer'}>
              {translationsStore.translate('paymentManagement.noPaymentMethodYet')}
            </div>}
            {defaultPaymentMethod && <div className={'AlreadyPresentPaymentMethodContainer'}>
              <div className={'PreviousPaymentMethodContainer'}>
                {defaultPaymentMethod.Type === 'CreditCard' ?
                  <CreditCardPaymentMethod defaultPaymentMethod={defaultPaymentMethod}/>
                  : <BankTransferPaymentMethod defaultPaymentMethod={defaultPaymentMethod}/>
                }
              </div>
              <AirButton
                className="ChangePaymentMethodButton"
                label={translationsStore.translate('paymentManagement.change')}
                size="large"
                onClick={this.toggleModalAddPaymentMethod} />
            </div>}
          </div>
          <PaymentMethodPopup visible={this.state.visiblePaymentMethodPopUp} customerDetails={customerDetails} onCancel={() => this.toggleModalAddPaymentMethod()} onSuccessFullPaymentMethodChange={() => this.loadPaymentsMethods()}/>
        </Spin>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/PaymentManagementDashboard/PaymentManagementCard/PaymentManagementCard.js